/**
 * Generic comparator for TanStack tables.
 * Handles numeric, string, and null values consistently.
 */
export const TanstackSortingFn = (a, b, colId) => {
  const aVal = a.getValue(colId);
  const bVal = b.getValue(colId);

  if (aVal == null && bVal == null) return 0;
  if (aVal == null) return -1;
  if (bVal == null) return 1;

  const aStr = String(aVal).trim();
  const bStr = String(bVal).trim();

  const aNum = Number(aStr);
  const bNum = Number(bStr);
  const isNumeric = !isNaN(aNum) && !isNaN(bNum);

  if (isNumeric) {
    return aNum - bNum;
  }

  return aStr.localeCompare(bStr, undefined, { sensitivity: "base" });
};
